import React from 'react';
import PropTypes from 'prop-types';
import StatusText from '../StatusText';
import ProgressBar from '../ProgressBar';
//import ToggleButton from '../Buttons/ToggleButton'
import BasePage from '../../baseClasses/BasePage';
import { connect } from 'react-redux';
import dataModel from '../../models/DataModel';
import { project_root, complete_project_root_mobile } from  '../../dao/ProjectsDAO';

import './ProjectDetailsHeader.scss';

export class ProjectDetailsHeader extends BasePage {
  constructor(props){
    super(props);
    ProjectDetailsHeader.propTypes = {
      project: PropTypes.object.isRequired,
      hideStatusBar: PropTypes.bool, 
      loading: PropTypes.bool,
    };
    
    ProjectDetailsHeader.defaultProps = {
      hideStatusBar: false,
    };
    this.state = {
      selected: localStorage.getItem('is_offline_project')=='true', 
      loading: false,
    };

    this.handleMakeOfflineProject = this.handleMakeOfflineProject.bind(this);
    this.handleRemoveOfflineProject = this.handleRemoveOfflineProject.bind(this);

  }

  handleToggleChanged(selected) {
    this.setState({ loading: true });
    if(selected) {
      this.handleMakeOfflineProject(this.props.project.id);
    } else {
      this.handleRemoveOfflineProject(this.props.project.id);
    }
    this.setState({ selected: selected });
    localStorage.setItem('is_offline_project',selected); //save state (is offline project)
  }

  async handleMakeOfflineProject(project_id) {

    let project = await dataModel.projectsDAO.getProject(project_id);

    if (project){
      dataModel.projectsDAO.setOfflineProject(project_id, true, null, { recordDescriptor: complete_project_root_mobile })
      .then(project => {this.setState({ loading: false });})
      .catch(error => {});
    }
  }
  
  async handleRemoveOfflineProject(project_id){
    let project = await dataModel.projectsDAO.getProject(project_id);

    if(project) {
      dataModel.projectsDAO.setOfflineProject(project_id, false, null, { recordDescriptor: project_root })
      .then(project => {this.setState({ loading: false });})
      // .then( project => {})
      .catch(error => {});
    }
  } 

  render() {

    const { project, hideStatusBar } = this.props;
    const projectCompletionPercentage = Math.floor((project && project.tasks_count ? (project.tasks_completed_count ? project.tasks_completed_count : 0) / project.tasks_count : 0) * 100);
    const progressBar = <ProgressBar percentage={projectCompletionPercentage} thick={true}/>;
    //let toggleText=this.state.selected? "Available Offline" : "Offline this Project"
  
    return (
      <div className="project-details-header">
        <div className='container-details-header'>
          <div className={'project-details-header__title' + (project && project.name && project.name.length > 30 ? ' overflow' : '')}>
            { project.name || '' }
          </div>

          {/* <div className="container-toggle">
            <div className={'toggle-title' + (this.state.selected ? " offline-active" : "" ) + (this.loading ? " loading" : "")} >
              {toggleText}
            </div>
            <div className={`offline-toggle ${this.state.loading ? 'offline': ''}`}>
              <ToggleButton 
                readOnly={this.state.loading}
                selected={this.state.selected} 
                handleClick={this.handleToggleChanged} 
              />
            </div> 
          </div> */}
        </div>

        <StatusText status={ project.status }/>

        { !hideStatusBar && 
          <div className="progress-container">
            <div className={'progress-bar-container'}>
              {progressBar}
            </div>
            <div className={'percentage-text'}>{projectCompletionPercentage + '%'}</div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    // currentUser: state.new_users.currentUser
  };
};
export default connect(mapStateToProps)(ProjectDetailsHeader);



// WEBPACK FOOTER //
// ./src/components/ProjectDetailsHeader/index.js